import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const Shirt: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        <IconSVG {...props}>
            <g clipPath="url(#clip0_507_285)">
                <IconPath
                    d="M6 8.25V23.25H18V8.25M18 18.75H21.75C21.9481 18.7474 22.1374 18.6676 22.2775 18.5275C22.4176 18.3874 22.4974 18.1981 22.5 18V6.75C22.5 5.1587 21.8679 3.63258 20.7426 2.50736C19.6174 1.38214 18.0913 0.75 16.5 0.75H15C15 1.54565 14.6839 2.30871 14.1213 2.87132C13.5587 3.43393 12.7956 3.75 12 3.75C11.2044 3.75 10.4413 3.43393 9.87868 2.87132C9.31607 2.30871 9 1.54565 9 0.75H7.5C5.9087 0.75 4.38258 1.38214 3.25736 2.50736C2.13214 3.63258 1.5 5.1587 1.5 6.75V18C1.50259 18.1981 1.58244 18.3874 1.72253 18.5275C1.86263 18.6676 2.05189 18.7474 2.25 18.75H6M6 11.25H18M6 14.25H18M6 17.25H18"
                    {...pathProps}
                />
            </g>
            <defs>
                <clipPath id="clip0_507_285">
                    <rect width="24" height="24" fill="transparent" />
                </clipPath>
            </defs>
        </IconSVG>
    );
};
